// Add your custom JS here.
jQuery( document ).ready(function( $ ) {
	if( jQuery( ".wp-block-gallery figure a")) setModalGallery();
	if( jQuery( ".is-style-photo-stack-gallery .wp-block-image" )) setStackGallery();
});




function setModalGallery() {
	jQuery('.wp-block-gallery figure a').attr("data-fancybox","gallery");
	jQuery('[data-fancybox="gallery"]').fancybox({
			loop		: true,
			infobar		: false,
			protect 	: true,
			buttons: [
		    "zoom",
		    "fullScreen",
		    "close"
		  ],
	});
}


function setStackGallery(){
	jQuery( ".is-style-photo-stack-gallery .wp-block-image" ).on('click', function(){
		jQuery(this).appendTo( ".is-style-photo-stack-gallery" );
	});
}